export default {
	login: {
		loginInTitle: 'User Login',
		loginAccount: 'Please input Account',
		loginPWD: 'Please input Password',
		code: 'Captcha',
		rememberMe: 'Remember me',
		AccountError: 'Please input a Right Account',
		PWError: 'Please input a password',
		codeError: 'Please input a Captcha',
		login: 'Login',
		privacyReadAndAgree: 'I have read and agree to the ',
		privacyPolicy: 'Privacy Policy',
		privacyError: 'Please agree to the Privacy Policy first',
	},
	privacyPolicy: {
		title: 'Privacy Policy',
		confirm: 'I have read',
		loadError: 'Failed to load privacy policy. Please try again later.',
	},
}
